import React, { useLayoutEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useLocation, useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';

// bootstrap
import 'bootstrap';

// css
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'flag-icons/css/flag-icons.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'jsvectormap/dist/jsvectormap.css';
import './index.css';
import './scss/react.scss';
import './scss/email.scss';
import 'bootstrap-social/bootstrap-social.css';


if ('scrollRestoration' in window.history) {
	window.history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);

const container = document.getElementById('root');
const root = createRoot(container);
function App() {
	let element = useRoutes(AppRoute);

	return element;
}

function ScrollToTop() {
	const { pathname, search } = useLocation();

	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname, search]);

	return null;
}

root.render(
  <BrowserRouter basename="/color-admin/admin/react">
	<ScrollToTop />
	<App />
  </BrowserRouter>
);
